import { Record, Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { float64_type, record_type, list_type, tuple_type, bool_type, option_type, array_type, anonRecord_type, class_type, string_type, union_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { UserLight, DataList_$reflection, Sensor_Status_$reflection, UserLight_$reflection, DataListSequence_$reflection, Rev_$reflection } from "../Shared.fs.js";
import { Secure_Admin_saveMonitoring, Secure_probes, Secure_sensor, FetchError_$reflection } from "../Fetch.fs.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { Types_SensorKind, Types_Full_$reflection } from "../../../iotpool-types/Project/Iotpool.Dotnet/fable/Library.fs.js";
import { FSharpMap__get_Values, FSharpMap__get_IsEmpty, FSharpMap__Remove, FSharpMap__get_Keys, FSharpMap__get_Item, FSharpMap__Add, add, filter, toList, FSharpMap__ContainsKey, FSharpMap__get_Count, empty, ofList } from "../fable_modules/fable-library-js.4.24.0/Map.js";
import { toArray as toArray_1, isEmpty, filter as filter_2, singleton, append, ofArray, empty as empty_1, map } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { equals, comparePrimitives } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Cmd_none, Cmd_batch, Cmd_OfPromise_either } from "../fable_modules/Fable.Elmish.3.1.0/cmd.fs.js";
import { Cmd_OfFunc_result } from "../fable_modules/Fable.Elmish.3.1.0/./cmd.fs.js";
import { map as map_1 } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { concat, mapIndexed, filter as filter_1, toList as toList_1, toArray, length, map as map_2 } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { unwrap, some, value as value_5 } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { toConsole, printf, toText } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { Inside_Heading_h5, Inside_Str, Inside_Heading_h1, Inside_Section } from "../GogoFulma.fs.js";
import * as react from "react";
import { Option, hero } from "../fable_modules/Fulma.2.16.0/Layouts/Hero.fs.js";
import { Modifier_IModifier, Screen, Size_ISize, Color_IColor } from "../fable_modules/Fulma.2.16.0/Common.fs.js";
import { localFormat } from "../fable_modules/Fable.Date.1.0.0/Date.Format.fs.js";
import { french } from "../fable_modules/Fable.Date.1.0.0/Date.Local.fs.js";
import { toLocalTime } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { column } from "../fable_modules/Fulma.2.16.0/Layouts/Column.fs.js";
import { Option as Option_1, tag as tag_11 } from "../fable_modules/Fulma.2.16.0/Elements/Tag.fs.js";
import LineChart from "./SensorComponents/LineChart.tsx";
import { Option as Option_4, columns } from "../fable_modules/Fulma.2.16.0/Layouts/Columns.fs.js";
import { DOMAttr, HTMLAttr } from "../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { Option as Option_2, icon } from "../fable_modules/Fulma.2.16.0/Elements/Icon.fs.js";
import { Fa_ISize, Fa_IconOption, Fa_i } from "../fable_modules/Fable.FontAwesome.2.0.0/FontAwesome.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { SimpleRefresher } from "./SensorComponents/Refresher.tsx";
import Refresher from "./SensorComponents/Refresher.tsx";
import { h4, Option as Option_3, h5 } from "../fable_modules/Fulma.2.16.0/Elements/Heading.fs.js";
import MultiSelectMonitoring from "./SensorComponents/MultiSelectMonitoring.tsx";
import MonitoringSelector from "./SensorComponents/MonitoringSelector.tsx";
import { Option as Option_5, section } from "../fable_modules/Fulma.2.16.0/Layouts/Section.fs.js";
import { item, left, level } from "../fable_modules/Fulma.2.16.0/Layouts/Level.fs.js";
import { multiGraph } from "../RechartsHelper.fs.js";
import { ResponsiveContainer } from "recharts";

export class Types_Filter extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["Label"];
    }
}

export function Types_Filter_$reflection() {
    return union_type("Page.Monitoring.Types.Filter", [], Types_Filter, () => [[]]);
}

export class Types_ToggleState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Up", "Down"];
    }
}

export function Types_ToggleState_$reflection() {
    return union_type("Page.Monitoring.Types.ToggleState", [], Types_ToggleState, () => [[], []]);
}

export class Types_ToggleKind extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NumSerie", "Name", "Kind", "Status"];
    }
}

export function Types_ToggleKind_$reflection() {
    return union_type("Page.Monitoring.Types.ToggleKind", [], Types_ToggleKind, () => [[], [], [], []]);
}

export class Types_Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Load", "SaveMonitoring", "OnSaveUser", "UnloadSensor", "UnloadSingleSensor", "LoadSensor", "OnGetSensor", "OnLoadProbes", "OnDisplayError", "RefreshData", "RefreshAllData", "ForceRefreshUser", "MonitoringError", "SensorPage", "UpdateSelectorList"];
    }
}

export function Types_Msg_$reflection() {
    return union_type("Page.Monitoring.Types.Msg", [], Types_Msg, () => [[], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Rev_$reflection(), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", Rev_$reflection()]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Types_Full_$reflection(), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", Types_Full_$reflection()]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item1", Types_Full_$reflection()], ["Item2", union_type("Microsoft.FSharp.Core.FSharpResult`2", [DataListSequence_$reflection(), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", DataListSequence_$reflection()]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", class_type("System.Exception")]], [["Item", string_type]], [], [["Item", UserLight_$reflection()]], [["Item", string_type]], [["Item", string_type]], [["Item", array_type(anonRecord_type(["label", string_type], ["value", string_type]))]]]);
}

export class Types_Model extends Record {
    constructor(SelectedSensor, AllSensorsMap, SelectorList, SelectedSensorsMap, Data, Error$, WaitingForLoading, FirstRefresh, Values, Monitoring, User) {
        super();
        this.SelectedSensor = SelectedSensor;
        this.AllSensorsMap = AllSensorsMap;
        this.SelectorList = SelectorList;
        this.SelectedSensorsMap = SelectedSensorsMap;
        this.Data = Data;
        this.Error = Error$;
        this.WaitingForLoading = WaitingForLoading;
        this.FirstRefresh = FirstRefresh;
        this.Values = Values;
        this.Monitoring = Monitoring;
        this.User = User;
    }
}

export function Types_Model_$reflection() {
    return record_type("Page.Monitoring.Types.Model", [], Types_Model, () => [["SelectedSensor", option_type(string_type)], ["AllSensorsMap", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, option_type(string_type)])], ["SelectorList", array_type(anonRecord_type(["label", string_type], ["value", string_type]))], ["SelectedSensorsMap", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, tuple_type(option_type(Types_Full_$reflection()), bool_type)])], ["Data", list_type(Sensor_Status_$reflection())], ["Error", option_type(string_type)], ["WaitingForLoading", bool_type], ["FirstRefresh", bool_type], ["Values", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, option_type(list_type(DataList_$reflection()))])], ["Monitoring", option_type(list_type(string_type))], ["User", UserLight_$reflection()]]);
}

export function Types_initialModel(list, user) {
    const matchValue = user.Monitoring;
    if (matchValue != null) {
        const monitoring = matchValue;
        return new Types_Model(undefined, ofList(map((s_1) => [s_1.Name, s_1.Title], list), {
            Compare: comparePrimitives,
        }), [], empty({
            Compare: comparePrimitives,
        }), list, undefined, false, true, empty({
            Compare: comparePrimitives,
        }), monitoring, user);
    }
    else {
        return new Types_Model(undefined, ofList(map((s) => [s.Name, s.Title], list), {
            Compare: comparePrimitives,
        }), [], empty({
            Compare: comparePrimitives,
        }), list, undefined, false, false, empty({
            Compare: comparePrimitives,
        }), undefined, user);
    }
}

export const State_hoursToFetch = 6;

export function State_Commands_getSensor(name, model) {
    return [new Types_Model(model.SelectedSensor, model.AllSensorsMap, model.SelectorList, model.SelectedSensorsMap, model.Data, model.Error, true, model.FirstRefresh, model.Values, model.Monitoring, model.User), Cmd_OfPromise_either(Secure_sensor, name, (response) => ((Item) => (new Types_Msg(6, [Item])))(response), (response_1) => ((Item_1) => (new Types_Msg(8, [Item_1])))(response_1))];
}

export function State_Commands_refreshSensor(name) {
    return Cmd_OfPromise_either(Secure_sensor, name, (response) => ((Item) => (new Types_Msg(6, [Item])))(response), (response_1) => ((Item_1) => (new Types_Msg(8, [Item_1])))(response_1));
}

export function State_Commands_getProbes(sensor, hours, model) {
    return [model, Cmd_OfPromise_either((tupledArg) => Secure_probes(tupledArg[0], tupledArg[1]), [sensor.Name, hours], (response) => ((tupledArg_1) => (new Types_Msg(7, [tupledArg_1[0], tupledArg_1[1]])))([sensor, response]), (response_1) => ((Item_2) => (new Types_Msg(8, [Item_2])))(response_1))];
}

export function State_Commands_refreshProbes(sensor, hours) {
    return Cmd_OfPromise_either((tupledArg) => Secure_probes(tupledArg[0], tupledArg[1]), [sensor.Name, hours], (response) => ((tupledArg_1) => (new Types_Msg(7, [tupledArg_1[0], tupledArg_1[1]])))([sensor, response]), (response_1) => ((Item_2) => (new Types_Msg(8, [Item_2])))(response_1));
}

export function State_Commands_saveMonitoring(data_, data__1, data__2, model) {
    return [model, Cmd_OfPromise_either((tupledArg) => Secure_Admin_saveMonitoring(tupledArg[0], tupledArg[1], tupledArg[2]), [data_, data__1, data__2], (response) => ((Item) => (new Types_Msg(2, [Item])))(response), (response_1) => ((Item_1) => (new Types_Msg(8, [Item_1])))(response_1))];
}

export function State_update(msg, model) {
    let list_4, matchValue, checkV, bind$0040, matchValue_4, updated_2, bind$0040_1, matchValue_5;
    switch (msg.tag) {
        case 14: {
            const list = msg.fields[0];
            const currentCount = FSharpMap__get_Count(model.SelectedSensorsMap) | 0;
            if ((list.length > currentCount) && ((currentCount + 1) > 5)) {
                return [model, Cmd_OfFunc_result(new Types_Msg(12, ["5 capteurs maximum sont autorisés pour le monitoring : désactivez-en un pour en activer un nouveau"]))];
            }
            else {
                const newSensorsToLoad = (list.length === 0) ? empty_1() : ofArray(map_1((x_1) => Cmd_OfFunc_result(new Types_Msg(5, [x_1.value])), list.filter((x) => !FSharpMap__ContainsKey(model.SelectedSensorsMap, x.value))));
                return [new Types_Model(model.SelectedSensor, model.AllSensorsMap, list, model.SelectedSensorsMap, model.Data, model.Error, model.WaitingForLoading, model.FirstRefresh, model.Values, model.Monitoring, model.User), Cmd_batch((list_4 = append(map((tupledArg) => Cmd_OfFunc_result(new Types_Msg(3, [tupledArg[0]])), (list.length === 0) ? toList(model.SelectedSensorsMap) : toList(filter((k, v) => {
                    if (list.some((x_2) => (x_2.value === k))) {
                        return false;
                    }
                    else {
                        return v[0] != null;
                    }
                }, model.SelectedSensorsMap))), newSensorsToLoad), append(singleton(Cmd_OfFunc_result(new Types_Msg(1, []))), list_4)))];
            }
        }
        case 10: {
            const commands_1 = map_2(State_Commands_refreshSensor, value_5(model.Monitoring));
            if (length(commands_1) > 0) {
                return [new Types_Model(model.SelectedSensor, model.AllSensorsMap, model.SelectorList, model.SelectedSensorsMap, model.Data, model.Error, true, false, model.Values, model.Monitoring, model.User), Cmd_batch(commands_1)];
            }
            else {
                return [new Types_Model(model.SelectedSensor, model.AllSensorsMap, model.SelectorList, model.SelectedSensorsMap, model.Data, model.Error, false, false, model.Values, model.Monitoring, model.User), Cmd_none()];
            }
        }
        case 2: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                const e = response.fields[0];
                if (e.tag === 2) {
                    const e_1 = e.fields[0];
                    return [new Types_Model(model.SelectedSensor, model.AllSensorsMap, model.SelectorList, model.SelectedSensorsMap, model.Data, e_1, false, model.FirstRefresh, model.Values, model.Monitoring, model.User), Cmd_OfFunc_result(new Types_Msg(12, [toText(printf("OnSaveUser %s"))(e_1)]))];
                }
                else {
                    return [new Types_Model(model.SelectedSensor, model.AllSensorsMap, model.SelectorList, model.SelectedSensorsMap, model.Data, "Unknown error", false, model.FirstRefresh, model.Values, model.Monitoring, model.User), Cmd_OfFunc_result(new Types_Msg(12, [toText(printf("OnSaveUser e %A"))(e)]))];
                }
            }
            else {
                return [model, (matchValue = model.SelectedSensor, (matchValue != null) ? Cmd_batch(ofArray([State_Commands_refreshSensor(matchValue), Cmd_OfFunc_result(new Types_Msg(11, [model.User]))])) : Cmd_OfFunc_result(new Types_Msg(11, [model.User])))];
            }
        }
        case 7: {
            const sensor = msg.fields[0];
            const data = msg.fields[1];
            if (data.tag === 1) {
                const updated_1 = add(sensor.Name, undefined, model.Values);
                const updatedSelectedMap_1 = FSharpMap__Add(model.SelectedSensorsMap, sensor.Name, [sensor, false]);
                return [new Types_Model(model.SelectedSensor, model.AllSensorsMap, toArray(map_2((x_4) => {
                    let matchValue_2, t_1;
                    return {
                        label: (matchValue_2 = value_5(FSharpMap__get_Item(model.SelectedSensorsMap, x_4)[0]).Title, (matchValue_2 == null) ? x_4 : ((t_1 = matchValue_2, toText(printf("%s (%s)"))(t_1)(x_4)))),
                        value: x_4,
                    };
                }, FSharpMap__get_Keys(updatedSelectedMap_1))), updatedSelectedMap_1, model.Data, model.Error, false, model.FirstRefresh, model.Values, model.Monitoring, model.User), Cmd_none()];
            }
            else {
                const updated = add(sensor.Name, (checkV = ((v_2, s_3) => {
                    let matchResult;
                    if (v_2 != null) {
                        if (v_2) {
                            matchResult = 0;
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                    switch (matchResult) {
                        case 0:
                            return some(s_3);
                        default:
                            return undefined;
                    }
                }), toList_1(map_2(value_5, filter_1((d) => (d != null), mapIndexed((i, s_4) => {
                    switch (i) {
                        case 0:
                            return undefined;
                        case 1:
                            return checkV(sensor.S1Activated, s_4);
                        case 2:
                            return checkV(sensor.S2Activated, s_4);
                        case 3:
                            return checkV(sensor.S3Activated, s_4);
                        case 4:
                            return checkV(sensor.S4Activated, s_4);
                        case 5:
                            return checkV(sensor.S5Activated, s_4);
                        case 6:
                            return checkV(sensor.S6Activated, s_4);
                        case 7:
                            return checkV(sensor.S7Activated, s_4);
                        case 8:
                            return checkV(sensor.S8Activated, s_4);
                        case 9:
                            return checkV(sensor.S9Activated, s_4);
                        case 10:
                            return checkV(sensor.S10Activated, s_4);
                        default:
                            return undefined;
                    }
                }, data.fields[0].Docs))))), model.Values);
                const updatedSelectedMap = FSharpMap__Add(model.SelectedSensorsMap, sensor.Name, [sensor, false]);
                return [new Types_Model(model.SelectedSensor, model.AllSensorsMap, toArray(map_2((x_3) => {
                    let matchValue_1, t;
                    return {
                        label: (matchValue_1 = value_5(FSharpMap__get_Item(model.SelectedSensorsMap, x_3)[0]).Title, (matchValue_1 == null) ? "" : ((t = matchValue_1, toText(printf("%s (%s)"))(t)(x_3)))),
                        value: x_3,
                    };
                }, FSharpMap__get_Keys(updatedSelectedMap))), updatedSelectedMap, model.Data, model.Error, false, model.FirstRefresh, updated, model.Monitoring, model.User), Cmd_none()];
            }
        }
        case 9: {
            const s_5 = FSharpMap__get_Item(model.SelectedSensorsMap, msg.fields[0])[0];
            const updatedSelectedMap_2 = FSharpMap__Add(model.SelectedSensorsMap, value_5(s_5).Name, [s_5, true]);
            return State_Commands_getProbes(value_5(s_5), State_hoursToFetch, new Types_Model(model.SelectedSensor, model.AllSensorsMap, model.SelectorList, updatedSelectedMap_2, model.Data, model.Error, true, model.FirstRefresh, model.Values, model.Monitoring, model.User));
        }
        case 4: {
            const name_2 = msg.fields[0];
            return [new Types_Model(model.SelectedSensor, model.AllSensorsMap, toArray(map_2((x_6) => {
                let matchValue_3, t_2;
                return {
                    label: (matchValue_3 = value_5(FSharpMap__get_Item(model.SelectedSensorsMap, x_6)[0]).Title, (matchValue_3 == null) ? x_6 : ((t_2 = matchValue_3, toText(printf("%s (%s)"))(t_2)(x_6)))),
                    value: x_6,
                };
            }, filter_1((x_5) => (x_5 !== name_2), FSharpMap__get_Keys(model.SelectedSensorsMap)))), model.SelectedSensorsMap, model.Data, model.Error, model.WaitingForLoading, model.FirstRefresh, model.Values, model.Monitoring, model.User), Cmd_batch(ofArray([Cmd_OfFunc_result(new Types_Msg(3, [name_2])), Cmd_OfFunc_result(new Types_Msg(1, []))]))];
        }
        case 3: {
            const s_6 = FSharpMap__get_Item(model.SelectedSensorsMap, msg.fields[0])[0];
            const updatedMap = FSharpMap__Remove(model.SelectedSensorsMap, value_5(s_6).Name);
            return [new Types_Model(undefined, FSharpMap__Add(model.AllSensorsMap, value_5(s_6).Name, value_5(s_6).Title), model.SelectorList, updatedMap, model.Data, model.Error, false, model.FirstRefresh, FSharpMap__Remove(model.Values, value_5(s_6).Name), model.Monitoring, (bind$0040 = model.User, new UserLight(bind$0040.Id, bind$0040.Email, bind$0040.Operator, bind$0040.Address1, bind$0040.Address2, bind$0040.City, bind$0040.Zip, bind$0040.Tel, bind$0040.Country, bind$0040.Company, bind$0040.Web, bind$0040.Color, bind$0040.Logo, bind$0040.Owner, bind$0040.UserKind, bind$0040.AppOptions, bind$0040.CustomPictures, ((matchValue_4 = model.User.Monitoring, (matchValue_4 == null) ? [undefined, empty_1()] : ((updated_2 = filter_2((v_3) => (v_3 !== value_5(s_6).Name), matchValue_4), [updated_2, updated_2]))))[0], bind$0040.ShareKey, bind$0040.Tags))), Cmd_none()];
        }
        case 6: {
            const sensor_1 = msg.fields[0];
            if (sensor_1.tag === 1) {
                const e_4 = sensor_1.fields[0];
                if (e_4.tag === 2) {
                    return [new Types_Model(model.SelectedSensor, model.AllSensorsMap, model.SelectorList, model.SelectedSensorsMap, model.Data, e_4.fields[0], false, model.FirstRefresh, model.Values, model.Monitoring, model.User), Cmd_none()];
                }
                else {
                    return [new Types_Model(model.SelectedSensor, model.AllSensorsMap, model.SelectorList, model.SelectedSensorsMap, model.Data, "Unknown error", false, model.FirstRefresh, model.Values, model.Monitoring, model.User), Cmd_OfFunc_result(new Types_Msg(12, ["OnGetSensor Unknown error"]))];
                }
            }
            else {
                const s_7 = sensor_1.fields[0];
                const updatedMap_1 = FSharpMap__Remove(model.AllSensorsMap, s_7.Name);
                return State_Commands_getProbes(s_7, State_hoursToFetch, new Types_Model(model.SelectedSensor, model.AllSensorsMap, model.SelectorList, FSharpMap__Add(model.SelectedSensorsMap, s_7.Name, [s_7, false]), model.Data, model.Error, model.WaitingForLoading, model.FirstRefresh, model.Values, model.Monitoring, model.User));
            }
        }
        case 8:
            return [new Types_Model(model.SelectedSensor, model.AllSensorsMap, model.SelectorList, model.SelectedSensorsMap, model.Data, msg.fields[0].message, false, model.FirstRefresh, model.Values, model.Monitoring, model.User), Cmd_none()];
        case 1: {
            toConsole(printf("SAVE MONITORING"));
            return State_Commands_saveMonitoring(model.User.Id, model.User.Email, toList_1(map_2((x_7) => x_7.value, model.SelectorList)), new Types_Model(model.SelectedSensor, model.AllSensorsMap, model.SelectorList, model.SelectedSensorsMap, model.Data, model.Error, true, model.FirstRefresh, model.Values, model.Monitoring, model.User));
        }
        case 5: {
            const name_4 = msg.fields[0];
            return [new Types_Model(name_4, model.AllSensorsMap, model.SelectorList, model.SelectedSensorsMap, model.Data, model.Error, true, model.FirstRefresh, model.Values, model.Monitoring, (bind$0040_1 = model.User, new UserLight(bind$0040_1.Id, bind$0040_1.Email, bind$0040_1.Operator, bind$0040_1.Address1, bind$0040_1.Address2, bind$0040_1.City, bind$0040_1.Zip, bind$0040_1.Tel, bind$0040_1.Country, bind$0040_1.Company, bind$0040_1.Web, bind$0040_1.Color, bind$0040_1.Logo, bind$0040_1.Owner, bind$0040_1.UserKind, bind$0040_1.AppOptions, bind$0040_1.CustomPictures, (matchValue_5 = model.User.Monitoring, (matchValue_5 == null) ? singleton(name_4) : append(singleton(name_4), matchValue_5)), bind$0040_1.ShareKey, bind$0040_1.Tags))), Cmd_none()];
        }
        default:
            return [model, Cmd_none()];
    }
}

export class View_SimpleChartData extends Record {
    constructor(date, value, k) {
        super();
        this.date = date;
        this.value = value;
        this.k = k;
    }
}

export function View_SimpleChartData_$reflection() {
    return record_type("Page.Monitoring.View.SimpleChartData", [], View_SimpleChartData, () => [["date", string_type], ["value", float64_type], ["k", float64_type]]);
}

export function View_root(model, dispatch) {
    let props_14, children_19, props_24;
    if (isEmpty(model.Data)) {
        return Inside_Section(singleton(Inside_Heading_h1(singleton(Inside_Str("Aucun capteur n\'est pour l\'instant référencé sur votre compte.")))));
    }
    else {
        const viz = FSharpMap__get_IsEmpty(model.Values) ? react.createElement(react.Fragment, {}) : hero(ofArray([new Option(1, []), new Option(6, [new Color_IColor(3, [])])]), toList_1(mapIndexed((index, k) => {
            let props_12, children_9, props_6, children_4, props_8, props_10;
            const values = FSharpMap__get_Item(model.Values, k);
            const patternInput = FSharpMap__get_Item(model.SelectedSensorsMap, k);
            const sensor = patternInput[0];
            const isLoading = patternInput[1];
            let title_1;
            const matchValue_1 = value_5(sensor).Title;
            title_1 = ((matchValue_1 == null) ? "" : matchValue_1);
            const graphs = (values != null) ? toList_1(mapIndexed((i, seq_1) => {
                let props_4;
                const data = toArray_1(map((value) => {
                    let v_3;
                    const _arg = value.Value;
                    switch (_arg.tag) {
                        case 2: {
                            v_3 = _arg.fields[0];
                            break;
                        }
                        case 1: {
                            throw new Error("not handled");
                            break;
                        }
                        default:
                            v_3 = _arg.fields[0];
                    }
                    const d = localFormat(french, "dd/MM HH:mm", toLocalTime(value.Date));
                    return new View_SimpleChartData(toText(printf("%s"))(d), v_3, v_3 + 1);
                }, seq_1.List));
                return column(empty_1(), ofArray([tag_11(ofArray([new Option_1(1, [isLoading ? (new Color_IColor(5, [])) : (new Color_IColor(1, []))]), new Option_1(4, [singleton(["style", {
                    marginLeft: "4rem",
                }])])]), singleton(toText(printf("%s"))(seq_1.Name))), (props_4 = {
                    brushHeight: 10,
                    chartIndex: (index + 1) * (i + 1),
                    data: data,
                    minHeight: 200,
                }, react.createElement(LineChart, props_4))]));
            }, values)) : singleton(react.createElement(react.Fragment, {}));
            let label;
            const matchValue_2 = value_5(sensor).Title;
            if (matchValue_2 == null) {
                label = k;
            }
            else {
                const t_1 = matchValue_2;
                label = toText(printf("%s (%s)"))(t_1)(k);
            }
            return columns(empty_1(), append(singleton((props_12 = [["style", {
                transformOrigin: "0 0",
                transform: "rotate(90deg)",
                marginTop: "14px",
                width: "15px",
                height: "100%",
                cursor: "pointer",
            }], new HTMLAttr(64, ["has-text-dark has-background-dark"]), new DOMAttr(40, [(_arg_1) => {
                dispatch(new Types_Msg(13, [k]));
            }])], (children_9 = [(props_6 = [["style", {
                marginLeft: "1.5rem",
                width: 250,
                fontWeight: "700",
                textTransform: "uppercase",
            }]], (children_4 = [icon(singleton(new Option_2(0, [new Size_ISize(0, [])])), singleton(Fa_i(singleton(new Fa_IconOption(11, ["fas fa-caret-right"])), []))), toText(printf("%s     ..."))(label)], react.createElement("div", keyValueList(props_6, 1), ...children_4))), (props_8 = [["style", {
                marginLeft: "1.5rem",
            }]], react.createElement("span", keyValueList(props_8, 1), k)), (props_10 = {
                index: index,
                isLoading: isLoading,
                key: label,
                name: k,
                refresh: (name_3) => {
                    dispatch(new Types_Msg(9, [name_3]));
                },
            }, react.createElement(Refresher, props_10))], react.createElement("div", keyValueList(props_12, 1), ...children_9)))), graphs));
        }, FSharpMap__get_Keys(model.Values))));
        let selector;
        const sensors = toArray(map_2((x_1) => {
            let t_2;
            const value_1 = FSharpMap__get_Item(model.AllSensorsMap, x_1);
            return {
                label: (value_1 == null) ? "" : ((t_2 = value_1, toText(printf("%s (%s)"))(t_2)(x_1))),
                value: x_1,
            };
        }, filter_1((x_2) => {
            const value_2 = FSharpMap__get_Item(model.AllSensorsMap, x_2);
            if (value_2 == null) {
                return false;
            }
            else {
                return true;
            }
        }, FSharpMap__get_Keys(model.AllSensorsMap))));
        const props_16 = [["style", {
            marginBottom: "2rem",
        }]];
        const children_12 = [h5(singleton(new Option_3(4, [])))(singleton("Sélectionnez les capteurs à monitorer")), (props_14 = {
            alreadySelected: model.SelectorList,
            customLabel: "😶 Aucun capteur sélectionné",
            list: sensors,
            onSelect: (list_4) => {
                dispatch(new Types_Msg(14, [list_4]));
            },
        }, react.createElement(MultiSelectMonitoring, props_14))];
        selector = react.createElement("div", keyValueList(props_16, 1), ...children_12);
        let selectedTiles;
        const values_1 = toList_1(filter_1((x_3) => (x_3[0] != null), FSharpMap__get_Values(model.SelectedSensorsMap)));
        selectedTiles = (isEmpty(values_1) ? react.createElement(react.Fragment, {}) : columns(singleton(new Option_4(2, [])), toList_1(map((s) => {
            const props = {
                isLoaded: true,
                loadSensor: (name) => {
                    dispatch(new Types_Msg(5, [name]));
                },
                locked: model.WaitingForLoading,
                name: s.Name,
                title: unwrap(s.Title),
                unloadSensor: (name_1) => {
                    dispatch(new Types_Msg(4, [name_1]));
                },
            };
            return react.createElement(MonitoringSelector, props);
        }, map((x_4) => value_5(x_4[0]), values_1)))));
        let data_1;
        const props_19 = [["style", {
            marginBottom: "2rem",
        }]];
        data_1 = react.createElement("div", keyValueList(props_19, 1), selectedTiles, viz);
        let mixedGraph;
        const keys = filter_1((k_1) => {
            const sensor_1 = FSharpMap__get_Item(model.SelectedSensorsMap, k_1)[0];
            if (equals(value_5(sensor_1).SensorKind, new Types_SensorKind(3, [])) ? true : equals(value_5(sensor_1).SensorKind, new Types_SensorKind(1, []))) {
                return true;
            }
            else {
                return equals(value_5(sensor_1).SensorKind, new Types_SensorKind(2, []));
            }
        }, FSharpMap__get_Keys(model.Values));
        let graphs_1;
        if (length(keys) <= 0) {
            graphs_1 = Inside_Section(singleton(Inside_Heading_h5(singleton(Inside_Str("...")))));
        }
        else {
            const values_2 = toList_1(concat(map_2((k_3) => {
                const value_4 = FSharpMap__get_Item(model.Values, k_3);
                if (value_4 == null) {
                    throw new Error("not handled");
                }
                else {
                    return value_4;
                }
            }, filter_1((k_2) => {
                const value_3 = FSharpMap__get_Item(model.Values, k_2);
                if (value_3 == null) {
                    return false;
                }
                else {
                    const v_5 = value_3;
                    return true;
                }
            }, keys))));
            graphs_1 = section(singleton(new Option_5(4, [singleton(new Modifier_IModifier(26, [new Screen(3, []), true]))])), ofArray([level(empty_1(), singleton(left(empty_1(), ofArray([item(empty_1(), singleton(h4(empty_1())(singleton("[BETA] Aperçu superposé des sondes de température")))), item(empty_1(), singleton(react.createElement("span", {}, "( Alignement des points à +/- 5min )")))])))), (children_19 = singleton(multiGraph(values_2, new Types_SensorKind(2, []))), (props_24 = {
                width: "100%",
                height: "100%",
                minWidth: 100,
                minHeight: 200,
            }, react.createElement(ResponsiveContainer, props_24, ...children_19)))]));
        }
        mixedGraph = react.createElement("div", {}, graphs_1);
        let spinner;
        if (model.WaitingForLoading) {
            const children_23 = [icon(singleton(new Option_2(0, [new Size_ISize(2, [])])), singleton(Fa_i(ofArray([new Fa_IconOption(11, ["fas fa-spinner"]), new Fa_IconOption(12, []), new Fa_IconOption(0, [new Fa_ISize(3, [])])]), [])))];
            spinner = react.createElement("span", {
                className: "has-text-info",
            }, ...children_23);
        }
        else {
            const children_25 = [icon(singleton(new Option_2(0, [new Size_ISize(2, [])])), singleton(Fa_i(ofArray([new Fa_IconOption(11, ["fas fa-info"]), new Fa_IconOption(0, [new Fa_ISize(3, [])])]), [])))];
            spinner = react.createElement("span", {
                className: "has-text-dark",
            }, ...children_25);
        }
        let simpleRefresher;
        if (model.FirstRefresh) {
            const props_31 = {
                refresh: () => {
                    dispatch(new Types_Msg(10, []));
                },
            };
            simpleRefresher = react.createElement(SimpleRefresher, props_31);
        }
        else {
            simpleRefresher = react.createElement(react.Fragment, {});
        }
        const children_29 = [selector, react.createElement("hr", {}), mixedGraph, react.createElement("hr", {}), spinner, simpleRefresher, data_1];
        return react.createElement(react.Fragment, {}, ...children_29);
    }
}

